import styled from "styled-components";
import { Button, Drawer, Popover } from "@renderbus/ui";
import { useTranslation } from "react-i18next";
import {
  getCouponTypeSubTitle,
  getCouponTypeTag,
} from "../constant/coupon-filter";
import { CouponType, CouponTypeMap } from "../constant";
import { ICouponDetailInfo } from "../types";
import OverTimeIcon from "@/assets/icons/coupon/over-time";
import OverTimeEnIcon from "@/assets/icons/coupon/over-time-en";
import FreezeIcon from "@/assets/icons/coupon/freeze-icon";
import FreezeEnIcon from "@/assets/icons/coupon/freeze-icon-en";
import { useGlobalStore } from "@/store/GlobalStore";
import { TransferModal } from "../components/transfer-modal";
import { TransferOperateDrawer } from "../components/transfer-operate-drawer";
import { useSubAccountInfo } from "../hooks/useSubAccoutInfo";
import { useTabStore } from "../store/tab-store";
import { CouponContentList } from "../constant/coupon-list";
import { useTransferRecord } from "../hooks/useTransferRecord";
import MoreButton from "@/assets/icons/coupon/more-button";
import { useMemo, useRef, useState } from "react";
import { useClickOutside } from "project-config/hooks/useClickOutside";
import { HaveSubAccount } from "project-config/constants";
import { FreeCouponTransferModal } from "./free-coupon-transfer-modal";

interface CouponCardStyleProps {
  bgColor?: string;
  textColor?: string;
  Expired?: boolean;
  fontSize?: string;
  lineHeight?: string;
  contentTitleColor?: string;
  contentColor?: string;
  buttonColor?: string;
  buttonBg?: string;
  borderColor?: string;
  isRenderingMember?: boolean;
  isLast?: boolean;
  isZh?: boolean;
  isFreeze?: boolean;
}
export const CouponCardWrapper = styled.div<CouponCardStyleProps>`
  background: ${(props) => props.bgColor};
  width: 300px;
  height: ${(props) => (props.isZh ? "166px" : "188px")};
  display: inline-flex;
  flex-direction: column;
  color: #60646b;
  font-size: 12px;
  border-radius: 4px;
  margin-right: 16px;
  margin-top: 20px;
  justify-content: space-between;
`;

const CouponCardHeader = styled.div<CouponCardStyleProps>`
  padding: 0 10px;
  background: ${(props) => props.bgColor};
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  justify-content: space-between;
  border-radius: 4px 4px 0 0;
  height: 54px;
  line-height: 1;
`;
const CouponCardTag = styled.div<CouponCardStyleProps>`
  line-height: 22px;
  border-radius: 3px;
  color: ${(props) => props.textColor};
  height: 24px;
  margin-right: 12px;
`;

const CouponCardTagSubTitle = styled.div<CouponCardStyleProps>`
  color: ${(props) => props.textColor};
  font-weight: 400;
  font-size: 12px;
`;

const CouponCardContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 12px;
  position: relative;
`;
const CouponSymbol = styled.div`
  font-size: 12px;
  margin-right: 2px;
`;
const CouponAmount = styled.div<CouponCardStyleProps>`
  color: ${(props) => props.color};
  font-size: ${(props) => props.fontSize};
  line-height: ${(props) => props.lineHeight};
  font-weight: 500;
`;
const CouponRemainContent = styled.div`
  font-size: 12px;
  font-weight: 400;
  display: flex;
  align-items: baseline;
`;
const CouponContentText = styled.span<CouponCardStyleProps>`
  flex: 1;
  color: ${(props) => props.contentTitleColor};
  white-space: pre-line;
`;
const CouponContentTitle = styled.div<CouponCardStyleProps>`
  display: flex;
  color: ${(props) => props.contentTitleColor};
  padding-left: 10px;
  background: ${(props) => props.bgColor};
  margin-top: ${(props) => props.isLast && "2px"};
  line-height: 20px;
`;
const CouponCardRenderingMember = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 17px;
  color: #ffffff;
`;

export const CouponCardNum = styled.div<CouponCardStyleProps>`
  color: ${(props) => props.color};
  text-align: right;
  padding-bottom: 3px;
  padding-top: 2px;
  height: 54px;
  p {
    margin: 0;
    font-weight: 700;
    font-size: 32px;
    display: inline-flex;
    align-items: baseline;
    line-height: 1;
    span {
      font-size: 20px;
      padding-right: 2px;
      padding-bottom: 4px;
    }
  }
`;

export const CouponCardDetail = styled.div<CouponCardStyleProps>`
  margin: ${(props) =>
    props.Expired || props.isFreeze ? "2px 12px 0 0" : "0 12px 0 0"};
  width: 214px;
  p {
    line-height: 18px;
    margin: 0;
    padding-top: 4px;
    padding-left: 10px;
  }
  svg {
    position: absolute;
    top: 6px;
    right: 0;
  }
`;
export const CouponCardFooter = styled.div<CouponCardStyleProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 28px;
  border-top: 1px solid ${(props) => props.borderColor};
  color: #5ead8d;
  margin: ${(props) =>
    props.Expired || props.isFreeze ? "0 12px 0 0" : "2px 12px"};
  span {
    color: ${(props) => props.contentTitleColor};
    padding-left: ${(props) => (props.Expired || props.isFreeze) && "12px"};
  }
  .renderbus-ui--popover {
    line-height: 1;
    cursor: pointer;
    .ant-popover {
      border-radius: 4px;
    }
    .ant-popover-content {
      margin-top: -6px !important;
      border-radius: 4px;
    }
    .ant-popover-inner {
      padding: 0;
    }
  }
`;
export const TransferButton = styled(Button)<CouponCardStyleProps>`
  height: 28px;
  font-size: 12px;
  border-radius: 20px !important;
  padding-top: 0;
  padding-bottom: 0;
  background: ${(props) => props.buttonBg || props.buttonColor}!important;
  border-color: ${({ buttonColor }) => buttonColor} !important;
`;
const PopoverWrapper = styled.div`
  min-width: 100px;
  padding: 0 10px;
  background: #292b2f;
  border: 1px solid #515356;
  border-radius: 4px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
`;

export interface CouponCardProps {
  data: ICouponDetailInfo;
  isOverTimeCoupon: (value: number, type: boolean) => boolean;
}

export default function Coupon(props: CouponCardProps) {
  const [showPopover, setShowPopover] = useState(false);
  const couponRef = useRef<HTMLDivElement>(null);
  const { currencySymbol, isZh, isSubAccount, userInfo } = useGlobalStore();
  const {
    isTransferModalOpen,
    setTransferModalOpen,
    isFreeCouponTransferModalOpen,
    setFreeCouponTransferModalOpen,
    handleTransferAmount,
    transferForm,
    isLoading,
    freeCouponTransferForm,
    handleTransferCoupon,
  } = useSubAccountInfo();
  const { t } = useTranslation("coupon");
  const {
    transferCoupon,
    setTransferCoupon,
    setCurrentAmount,
    cleanTransferForm,
    defaultSubAccount,
    currentTab,
    couponId,
    setCouponId,
    isMainUser,
  } = useTabStore();
  const { data } = props;
  const cardDetail = CouponTypeMap.get(
    !!data.isExpired
      ? CouponType.Expired
      : Boolean(data.isFreeze)
      ? CouponType.Freeze
      : currentTab
  );
  const { openDrawer, setOpenDrawer, transferData, setCurrentCouponNo } =
    useTransferRecord();
  const showTransferButton = useMemo(
    () =>
      cardDetail?.type !== CouponType.Expired &&
      cardDetail?.type !== CouponType.Freeze,
    [cardDetail?.type]
  );
  const showTransferRecordButton = useMemo(
    () => !isSubAccount && isMainUser,
    [isSubAccount, isMainUser]
  );

  const CouponButtonList = useMemo(() => {
    return [
      {
        label:
          isSubAccount || !isMainUser
            ? t("coupon_pages_get_way_transfer_to_main_account")
            : t("coupon_pages_get_way_transfer"),
        show: showTransferButton,
        onClick: () => {
          setShowPopover(false);
          setTransferCoupon(data.couponNo);
          if (currentTab === CouponType.RenderingMember) {
            setCouponId(data.id || 0);
            setFreeCouponTransferModalOpen(true);
          } else {
            setTransferModalOpen(true);
            setCurrentAmount(
              `${currencySymbol}${
                data.couponBalance !== data.couponAmount
                  ? data.couponBalance
                  : data.couponAmount
              }`
            );
          }
        },
      },
      {
        label: t("coupon_transfer_record"),
        show: showTransferRecordButton,
        onClick: () => {
          setCurrentCouponNo(data.couponNo);
          setOpenDrawer(true);
          setShowPopover(false);
        },
      },
    ].filter((item) => item.show);
  }, [
    t,
    showTransferButton,
    showTransferRecordButton,
    setTransferModalOpen,
    setTransferCoupon,
    data.couponNo,
    data.couponBalance,
    data.couponAmount,
    data.id,
    setCurrentAmount,
    currencySymbol,
    setCurrentCouponNo,
    setOpenDrawer,
    isSubAccount,
    currentTab,
    setFreeCouponTransferModalOpen,
    setCouponId,
    isMainUser,
  ]);
  const isShowMoreBtn = useMemo(
    () =>
      CouponButtonList.length &&
      (isSubAccount ||
        (userInfo && userInfo.haveSubAccount === HaveSubAccount.Yes)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [CouponButtonList.length, userInfo?.haveSubAccount]
  );
  useClickOutside(couponRef, () => setShowPopover(false), true);
  if (!cardDetail) return null;
  const {
    color,
    contentBg,
    subColor,
    contentTitleColor,
    contentColor,
    tabBgColor,
    borderColor,
    amountColor,
  } = cardDetail;
  const currentCardContentField =
    CouponContentList(isSubAccount || !isMainUser).get(currentTab) || [];
  const isFreeze = Boolean(data.isFreeze);

  return (
    <CouponCardWrapper bgColor={contentBg} isZh={isZh} ref={couponRef}>
      <CouponCardHeader bgColor={tabBgColor}>
        <div>
          <CouponCardTag textColor={color}>
            {t(getCouponTypeTag(data?.type))}
          </CouponCardTag>
          <CouponCardTagSubTitle textColor={subColor}>
            {t(getCouponTypeSubTitle(data?.type))}
          </CouponCardTagSubTitle>
        </div>
        {currentTab === CouponType.RenderingMember ? (
          data.isExpired ? (
            ""
          ) : (
            <CouponCardRenderingMember>
              {t("coupon_vip_only_one")}
            </CouponCardRenderingMember>
          )
        ) : (
          <CouponCardNum color={amountColor}>
            <p>
              <CouponSymbol>{currencySymbol}</CouponSymbol>
              <CouponAmount
                color={amountColor}
                fontSize={
                  data.couponBalance !== data.couponAmount ? "24px" : "36px"
                }
                lineHeight={
                  data.couponBalance !== data.couponAmount ? "28px" : "42px"
                }
              >
                {data.couponAmount}
              </CouponAmount>
            </p>
            {data.couponBalance !== data.couponAmount && (
              <CouponRemainContent>
                {t("coupon_pages_remaining")}&nbsp;&nbsp;
                <CouponSymbol>{currencySymbol}</CouponSymbol>
                <CouponAmount
                  color={amountColor}
                  fontSize={"18px"}
                  lineHeight={"21px"}
                >
                  {data.couponBalance}
                </CouponAmount>
              </CouponRemainContent>
            )}
          </CouponCardNum>
        )}
      </CouponCardHeader>
      <CouponCardContent>
        <CouponCardDetail Expired={data.isExpired} isFreeze={isFreeze}>
          {currentCardContentField.map((p, i) => {
            return (
              p.visible(data) && (
                <CouponContentTitle
                  contentTitleColor={contentTitleColor}
                  bgColor={
                    p.key === "expired"
                      ? "linear-gradient(90deg, rgba(50, 89, 87, 0.28) 0%, rgba(0, 0, 0, 0) 100%)"
                      : p.key === "freeze"
                      ? "linear-gradient(90deg, rgba(95, 158, 160, 0.28) 0%, rgba(0, 0, 0, 0) 100%)"
                      : "transparent"
                  }
                  isLast={
                    p.key && ["expired", "freeze"].includes(p.key)
                      ? true
                      : false
                  }
                >
                  {t(p.title)}&nbsp;&nbsp;
                  <CouponContentText contentTitleColor={contentColor}>
                    {t(p.content(data)?.key || p.content(data).value, {
                      day: p.content(data).value,
                    })}
                  </CouponContentText>
                </CouponContentTitle>
              )
            );
          })}
          {data.isExpired && (isZh ? <OverTimeIcon /> : <OverTimeEnIcon />)}
          {isFreeze && (isZh ? <FreezeIcon /> : <FreezeEnIcon />)}
        </CouponCardDetail>
      </CouponCardContent>
      <CouponCardFooter
        contentTitleColor={contentTitleColor}
        Expired={data.isExpired}
        isFreeze={isFreeze}
        borderColor={borderColor}
      >
        <span>{`NO.${data.couponNo}`}</span>
        {isShowMoreBtn ? (
          <Popover
            placement="bottomLeft"
            arrow={false}
            open={showPopover}
            content={
              <PopoverWrapper>
                {CouponButtonList.map((item) => (
                  <div onClick={item.onClick} key={item.label}>
                    {item.label}
                  </div>
                ))}
              </PopoverWrapper>
            }
          >
            <>
              <MoreButton onClick={() => setShowPopover(true)} />
            </>
          </Popover>
        ) : (
          ""
        )}
      </CouponCardFooter>
      <TransferModal
        open={isTransferModalOpen}
        form={transferForm}
        modalProps={{
          onCancel: () => {
            setTransferModalOpen(false);
          },
          onOk: () => {
            handleTransferAmount(transferCoupon);
          },
          afterClose: () => {
            cleanTransferForm(transferForm, defaultSubAccount);
          },
          footer: [
            <Button
              key="back"
              onClick={() => {
                setTransferModalOpen(false);
              }}
            >
              {t("coupon_modal_cancel_text")}
            </Button>,
            <Button
              key="submit"
              type="primary"
              loading={isLoading}
              onClick={() => {
                handleTransferAmount(transferCoupon);
              }}
            >
              {t("coupon_modal_confirm_text")}
            </Button>,
          ],
        }}
      />
      <FreeCouponTransferModal
        open={isFreeCouponTransferModalOpen}
        form={freeCouponTransferForm}
        modalProps={{
          onCancel: () => {
            setFreeCouponTransferModalOpen(false);
          },
          onOk: () => {
            handleTransferCoupon(transferCoupon, couponId);
          },
          afterClose: () => {
            cleanTransferForm(freeCouponTransferForm, defaultSubAccount);
          },
        }}
      />
      <Drawer
        width={680}
        open={openDrawer}
        title={t("coupon_transfer_record")}
        onClose={() => setOpenDrawer(false)}
        drawerContent={
          <TransferOperateDrawer
            couponNo={data.couponNo}
            transferData={transferData}
          />
        }
      />
    </CouponCardWrapper>
  );
}
